var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDarkLightMode = function SvgDarkLightMode(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15 9a6 6 0 0 1-6 6v-2a4 4 0 0 0 0-8V3a6 6 0 0 1 6 6M9 5a4 4 0 1 0 0 8zm8 4A8 8 0 1 1 1 9a8 8 0 0 1 16 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDarkLightMode);
export { ForwardRef as Icon };
export default "img/element-icons/roomlist/dark-light-mode.328ce0f.svg";